import { createStyles, getSize } from '@mantine/styles';
var useStyles = createStyles(function (theme, _ref) {
  var padding = _ref.padding;
  return {
    body: {
      padding: getSize({
        size: padding,
        sizes: theme.spacing
      }),
      "&:not(:only-child)": {
        paddingTop: 0
      }
    }
  };
});
export default useStyles;